<template>
    <div class="colorTextComponent">
      <select @change="changeColorText" class="cmpt">
          <option v-for="color in colors" v-bind:value="color.id" v-bind:selected="label.current_color == color.id">{{color.title}}</option>
      </select>
    </div>
</template>
<script>
    export default {
        props   : ['colors', 'label'],
        methods : {
            changeColorText () {
                var params = {
                    record : this.label,
                    colorId : $jQuery( event.target ).val()
                }
                this.$store.dispatch( 'changeColorText', params );
            }
        }
    }
</script>
<style scoped>
    select {
        width       : 100%;
        font-family : SourceSansPro;
        font-size   : 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ColorText/Color.vue